module.exports = __webpack_public_path__ + "static_pc/img/team3.5b95341f.png";